let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("96uAO")).then(() => parcelRequire('blaFr'));